import { Component, Input } from '@angular/core';

@Component({
  selector: 'igo-message-center',
  template: require('./message-center.component.html'),
  styles: [require('./message-center.component.styl')],
})

export class MessageCenterComponent {

  static defaultOptions = {
    timeOut: 5000,
    hasCloseIcon: false,
    showProgressBar: true,
    pauseOnHover: true,
    clickToClose: true,
    maxLength: 100,
    maxStack: 3,
    preventDuplicates: true
  };

  @Input()
  get options(): any {
    return Object.assign(
      {}, MessageCenterComponent.defaultOptions, this._options);
  }
  set options(value: any) {
    this._options = value;
  }
  private _options: any = {};

  constructor() { }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/core/message/message-center/message-center.component.ts